module.exports = __webpack_public_path__ + "media/สองแสนล้านภพสองแสนล้านชาติยืนนิ่งๆ.735637b0.mp3";